import { motion } from 'framer-motion'
import { Heart, Sparkles, CheckCircle } from 'lucide-react'
import FeatureLayout from '../../components/FeatureLayout'
import { useLanguage } from '../../contexts/LanguageContext'

export default function CheckInPage() {
  const { t } = useLanguage()

  const questions = [
    t('checkIn.modal.question1'),
    t('checkIn.modal.question2'),
    t('checkIn.modal.question3'),
    t('checkIn.modal.question4'),
    t('checkIn.modal.question5'),
  ]

  return (
    <FeatureLayout
      title={t('checkIn.modal.title')}
      subtitle={t('checkIn.modal.subtitle')}
      gradientFrom="from-pink-500"
      gradientTo="to-rose-500"
      icon={<Heart className="h-10 w-10 text-white" />}
      featureName="Financial Check-In"
    >
      {/* What Is Section */}
      <section className="mb-16">
        <div className="bg-gradient-to-r from-pink-500/10 to-rose-500/10 rounded-3xl p-8 lg:p-12 border border-pink-500/20">
          <div className="flex items-start gap-6">
            <div className="p-4 bg-pink-500/20 rounded-2xl">
              <Sparkles className="h-8 w-8 text-pink-400" />
            </div>
            <div>
              <h2 className="text-3xl font-bold text-white mb-4">{t('checkIn.modal.whatIs')}</h2>
              <p className="text-gray-300 text-lg leading-relaxed">{t('checkIn.modal.intro')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Weekly Questions */}
      <section className="mb-16">
        <h2 className="text-3xl font-bold text-white mb-8">{t('checkIn.modal.questions')}</h2>

        <div className="space-y-4">
          {questions.map((question, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="bg-white/5 rounded-2xl p-6 border border-pink-500/20 flex items-center gap-4"
            >
              <div className="w-10 h-10 bg-pink-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-pink-400 font-bold">{i + 1}</span>
              </div>
              <p className="text-gray-300">{question}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section>
        <div className="bg-gradient-to-r from-pink-600/20 to-rose-600/20 rounded-3xl p-8 lg:p-12 border border-pink-500/30 text-center">
          <CheckCircle className="h-16 w-16 text-pink-400 mx-auto mb-6" />
          <h2 className="text-3xl font-bold text-white mb-4">{t('checkIn.modal.cta')}</h2>
          <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto">
            {t('checkIn.modal.ctaDescription')}
          </p>
          <a
            href="/#waitlist"
            className="inline-block px-8 py-4 bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white font-semibold rounded-xl transition-all transform hover:scale-105"
          >
            Join Waitlist Now
          </a>
        </div>
      </section>
    </FeatureLayout>
  )
}
